module.exports = __webpack_public_path__ + "img/light-symbol@3x.e178c0d2.png";